

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Task from '@/web-task'
import selectLawyer from './selectLawyer.vue'
import litigationPlan from './litigationPlan.vue'
import resultInfo from './resultInfo.vue'
import UploadData from './UploadData.vue'
import Info from '@/views/AiiTasks/Info.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import LawsuitApi from '@/api/lawsuit'
import { updateViewer } from '@/utils/util'
import {
	DAI_JIE_DAN,
	YI_GUAN_DAN,
	YI_QU_XIAO,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
} from '@/web-task/config.ts'

let lawyerViewer: any = ''
let bottomViewer: any = ''

@Component({
	components: {
		selectLawyer,
		litigationPlan,
		resultInfo,
		Info,
		ImageList,
		UploadData,
		StaffInfo,
	},
})
export default class lawsuitTab extends Vue {
	private lawyerInfo: any = {}
	private taskInfo: any = {}
	private caseInfo: any = {}
	private DAI_JIE_DAN: string = DAI_JIE_DAN

	@Prop()
	public task!: any

	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	private activeKey!: any

	private get isReadonly() {
		// 案件资料是否只读
		let res = false
		switch (this.order.orderStatus) {
			case YI_GUAN_DAN:
			case YI_QU_XIAO:
			case DAI_ZHONG_SHEN:
			case YI_WAN_CHENG:
				res = true
				break
		}
		return res
	}

	private get supplyInfo() {
		let info = '（待律师上传）'
		switch (this.order.orderStatus) {
			case YI_GUAN_DAN:
			case YI_QU_XIAO:
			case DAI_ZHONG_SHEN:
			case YI_WAN_CHENG:
				info = ''
				break
		}
		return info
	}

	@Watch('task', { immediate: true })
	private onTaskChange() {
		if (this.task instanceof Task) {
			this.lawyerInfo = this.task.getLawyerInfo()
			this.taskInfo = this.task.getTaskInfo()
			this.caseInfo = this.task.getCaseInfo()
			this.caseInfo = Object.assign({}, this.caseInfo, {
				span: {
					案件涉诉保单: 24,
					应诉要求: 24,
				},
			})
			this.$nextTick(() => {
				// 详情接口返回数据后 再给图片绑定查看大图
				lawyerViewer = updateViewer(lawyerViewer, '.lawyer-info')
				bottomViewer = updateViewer(bottomViewer, '.bottom-pic')
			})
		}
	}

	@Watch('activeKey')
	private onActiveKeyChange() {
		// v-if之间切换时，DOM已更新 需重新绑定事件
		if (this.activeKey === '1') {
			this.$nextTick(() => {
				lawyerViewer = updateViewer(lawyerViewer, '.lawyer-info')
				bottomViewer = updateViewer(bottomViewer, '.bottom-pic')
			})
		} else {
			lawyerViewer && lawyerViewer.destroy()
			bottomViewer && bottomViewer.destroy()
			lawyerViewer = ''
			bottomViewer = ''
		}
	}

	private getDetail() {
		this.$emit('getDetail')
	}

	private onUploadDataChange(data: any) {
		LawsuitApi.updateMedia({
			orderId: this.order.orderId,
			...data,
		})
			.then((res: any) => {})
			.catch((err: any) => {
				this.$message.error('修改失败')
			})
	}

	private deactivated() {
		lawyerViewer && lawyerViewer.destroy()
		bottomViewer && bottomViewer.destroy()
		lawyerViewer = ''
		bottomViewer = ''
	}
}
